export function createArrayCartData(items, action) {
  let formData = new FormData();

  formData.append(
    "itemsData",
    JSON.stringify(
      items.map(item => {
        const result = {
          itemId: item.productId || item.articule_id || item.id,
          quantity: item.quantity || item.qty,
          store_id: item.store_id
        };
        return !item.unrecognized
          ? result
          : {
              ...result,
              search: item.requested_article,
              oem: item.oem,
              name: item.name,
              unrecognized: item.unrecognized
            };
      })
    )
  );
  formData.append("action", action);

  return formData;
}
